import { SelectedProductDTO } from "@models/platform-analysis/entities/steps/feature";
import { useTheme } from "@mui/material";
import { PDFTableCell } from "@pages/platform-analysis/components/buttons/export-pdf/components/layouts/tables/table-cell";
import {
  PDFTableRow,
  PDFTableRowProps,
} from "@pages/platform-analysis/components/buttons/export-pdf/components/layouts/tables/table-row";
import {
  TABLE_CELL_WIDTH,
  TABLE_FIRST_CELL_WIDTH,
} from "@pages/platform-analysis/components/buttons/export-pdf/constant";
import { useStyles } from "@pages/platform-analysis/components/buttons/export-pdf/styles";
import { Text, View } from "@react-pdf/renderer";

interface PDFSummaryAnalysisHeaderProps {
  selectedProducts?: SelectedProductDTO[];
  title?: string;
  titleFontSize?: number;
  showSubProductName?: boolean;
  staticFirstCellWidth?: number;
  staticFollowingCellWidth?: number;
  type?: PDFTableRowProps["type"];
  forceShowBorderBottom?: boolean;
  imageSize?: number;
}

export const PDFSummaryAnalysisHeaderV2 = ({
  selectedProducts,
  title,
  titleFontSize,
  type = "HeaderLine",
  showSubProductName = false,
  staticFirstCellWidth,
  staticFollowingCellWidth,
  forceShowBorderBottom = false,
  imageSize = 35,
}: PDFSummaryAnalysisHeaderProps) => {
  const { typographyStyle } = useStyles();
  const { palette } = useTheme();
  const firstCellWidth = staticFirstCellWidth ?? TABLE_FIRST_CELL_WIDTH;
  const followingCellWidth = staticFollowingCellWidth ?? TABLE_CELL_WIDTH;

  return (
    <PDFTableRow type={type} forceShowBorderBottom={forceShowBorderBottom}>
      <PDFTableCell width={firstCellWidth}>
        <Text
          style={{
            ...typographyStyle.body2,
            color: palette.text.primary,
            fontWeight: "bold",
          }}
        >
          {title}
        </Text>
      </PDFTableCell>

      {selectedProducts?.map((product, index) => (
        <View
          key={index}
          style={{
            paddingLeft: 5,
            paddingRight: 5,
            paddingTop: 5,
            paddingBottom: 5,
            width: followingCellWidth,
            maxWidth: followingCellWidth,
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            borderColor: "#7C8493",
            borderRightWidth: 1,
            backgroundColor: "transparent",
            position: "relative",
          }}
        >
          {product.isProductMain && (
            <Text
              style={{
                ...typographyStyle.body2,
                alignItems: "center",
                borderRadius: 10,
                borderWidth: 0.5,
                borderColor: "#FFAC8A",
                backgroundColor: "#FFE3D8",
                fontWeight: "bold",
                color: "#E84D1E",
                position: "absolute",
                top: 1,
                right: 1,
                fontSize: 5,
                paddingTop: 2,
                paddingRight: 1,
                paddingLeft: 2,
              }}
            >
              Main
            </Text>
          )}

          <View
            style={{
              flexDirection: "column",
              alignItems: "center",
              justifyContent: showSubProductName ? "flex-start" : undefined,
              width: "100%",
              height: "100%",
              gap: 5,
            }}
          >
            <View
              style={{
                flexDirection: "column",
                alignItems: "center",
                justifyContent: showSubProductName ? "center" : undefined,
                height: showSubProductName ? "100%" : undefined,
                width: "100%",
                gap: 2,
              }}
            >
              <Text
                style={{
                  ...typographyStyle.body2,
                  color: palette.text.primary,
                  fontWeight: "bold",
                  textAlign: "center",
                  marginTop: imageSize,
                  fontSize: titleFontSize
                    ? titleFontSize
                    : typographyStyle.body2.fontSize,
                }}
              >
                {product?.productName}
              </Text>

              {showSubProductName && product?.subProductName && (
                <Text
                  style={{
                    ...typographyStyle.body2,
                    color: palette.text.primary,
                    fontWeight: "bold",
                    textAlign: "center",
                    fontSize: titleFontSize
                      ? titleFontSize
                      : typographyStyle.body2.fontSize,
                    maxHeight: 20,
                  }}
                >
                  {product?.subProductName}
                </Text>
              )}
            </View>
          </View>
        </View>
      ))}
    </PDFTableRow>
  );
};
